export default __webpack_public_path__ + "static/media/slide7.7fce16fd.jpg";